/*
 * SPDX-FileCopyrightText: 2023 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useNoteSettingsContext } from '../note-settings/note-settings-context'
import { TimeFromNow } from '../time-from-now'
import { NoteInfoEntry } from './note-info-entry'
import { DateTime } from 'luxon'
import React, { useMemo } from 'react'
import { Save as IconSave } from 'react-bootstrap-icons'
import { useTranslation } from 'react-i18next'

/**
 * Renders an info line about the time that the note content was last updated.
 */
export const NoteInfoLineUpdatedAt: React.FC = () => {
  useTranslation()
  const noteUpdateTime = useNoteSettingsContext().info.updatedAt
  const noteUpdateDateTime = useMemo(() => DateTime.fromISO(noteUpdateTime), [noteUpdateTime])

  return (
    <NoteInfoEntry titleI18nKey={'editor.noteInfo.lastUpdated'} icon={IconSave}>
      <TimeFromNow time={noteUpdateDateTime} />
    </NoteInfoEntry>
  )
}
